import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import PpwrDashboardService from 'src/modules/3rd-party-management/apis/admin/PpwrDashboardService';

export const PPWR_PACKAGING_TONNAGE_TREND_QUERY_KEY = '3rd-party-management-fetch-ppwr-packaging-tonnage-trend';

const MONTH_KEYS = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

const usePackagingTonnageTrend = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [PPWR_PACKAGING_TONNAGE_TREND_QUERY_KEY],
        queryFn: async () => {
            const service = PpwrDashboardService.getInstance();

            return await service.fetchPackagingTonnageTrend();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching packaging tonnage trend data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            categories: [],
            chartSeries: [],
        };
    }

    const categories = [];
    const tonnageValues = [];

    (data.series || []).forEach((element) => {
        const monthKey = parseInt((element.month || '').split('-')?.[1] || '0', 10);

        categories.push(t(MONTH_KEYS[monthKey] || element.month));
        tonnageValues.push(Number(element.tonnage) || 0);
    });

    return {
        ...query,
        categories,
        chartSeries: [
            {
                name: t('Packaging Tonnage'),
                data: tonnageValues,
                color: '#5664D2',
            },
        ],
    };
};

export default usePackagingTonnageTrend;
